<div class="container">
  <a class="navbar-brand logoLink" href=""><img src="./assets/img/TVS_Sathi_Logo.png" alt="logo" class="" /></a>

  <div id="navbar" class="navbar-collapse collapse">
    <ul class="nav navbar-nav navbar-right"></ul>
  </div>
  <div class="container screen-five">
    <div class="row flex-grid d-flex align-items-center">
      <div class="col-lg-6 col-md-6 order-sm-1">
        <div class="insta-card-details mt-2 pt-2 ml-2 mr-2">
          <form [formGroup]="basicdetailsform">
            <div class="block-bg-color">
              <div class="form-group custom-input">
                <div class="block-bg-color">
                  <div class="form-group custom-input">
                    <label class="control-label" style="color: #114984;font-weight: bold;">Income as per prior records
                    </label>
                    <input type="text" inputmode="numeric" value="{{previousincome}}" numberonly minlength="1"
                      maxlength="6" class="form-control reason-for" style="font-family: 'Figtree' !important" readonly />
                  </div>
                </div>
                <div class="block-bg-color">
                  <div class="form-group custom-input">
                    <label class="control-label">Your Monthly income
                      <span style="color: #ff0000">*</span></label>
                    <input type="text" class="form-control reason-for" [ngClass]="{
                        'is-invalid':
                          submitted &&
                          b.incomebandrange.errors &&
                          b.incomebandrange.touched}"
                      placeholder="" style="font-family: 'Figtree' !important" inputmode=" numeric" minlength="4" maxlength="6" formControlName="incomebandrange"
                      (keyup)="checkBorrowerIncome($event, 'borrowerIncome','incomebandrange')" [(ngModel)]="incomebandrange"
                      (keyup)="allowOnlyNumbers($event, incomebandrange, 2)" numberonly="incomebandrange">
                    <div *ngIf="
                        b.incomebandrange.touched && b.incomebandrange.errors
                      " class="invalid-feedback">
                      <div *ngIf="b.incomebandrange.errors.required">
                        <sup>*</sup> Enter Monthly income
                      </div>
                      <!-- <div *ngIf="b.incomebandrange.errors.min">
                        Borrower income should not be zero
                      </div> -->
                      <div *ngIf="b.incomebandrange.errors.pattern">
                        Enter valid amount
                      </div>
                      <div *ngIf="b.incomebandrange.errors.min || b.incomebandrange.errors.max "style="font-family: 'Figtree' !important">
                        Monthly income must be at least 4 digits or maximium 6 digits
                      </div>
                    </div>
                  </div>
                </div>

                <div>
                  <label class="control-label">Marital Status <span style="color: #ff0000">*</span></label>

                  <div class="col-lg-12">
                    <label class="container-one">
                      <input type="radio" name="radio" value="Married" (change)="onItemChange($event.target.value)"
                        class="form-check-input" checked="true" />
                      <span class="s-text">Married</span>
                      <span class="checkmark"></span>
                    </label>

                    <label class="container-one">
                      <input type="radio" name="radio" value="Unmarried" (change)="onItemChange($event.target.value)"
                        class="form-check-input" [checked]="" />
                      <span class="s-text">Single</span>
                      <span class="checkmark"></span>
                    </label>
                  </div>
                </div>

                <div *ngIf="this.showFamilyIncome">
                  <label class="control-label">Earning family members
                    <span style="color: #ff0000">*</span></label>

                  <div class="col-lg-12">
                    <div *ngIf="this.checkboxVal == 'Unmarried'">
                      <label class="container-one">
                        <input type="checkbox" name="checkbox" value="Father" [checked]="accepted"
                          (change)="onItemChangeFather($event)" class="form-check-input" [checked]="" />
                        <span class="s-text">Father</span>
                        <span class="checkmarkCheckbox"></span>
                      </label>
                      <label class="container-one">
                        <input type="checkbox" name="checkbox" value="Mother" [checked]="accepted"
                          (change)="onItemChangeMother($event)" class="form-check-input" [checked]="" />
                        <span class="s-text">Mother</span>
                        <span class="checkmarkCheckbox"></span>
                      </label>
                    </div>
                    <div *ngIf="this.checkboxVal == 'Married'">
                      <label class="container-one">
                        <input type="checkbox" name="checkbox" value="Spouse" [checked]="accepted"
                          (change)="onItemChangeSpouse($event)" />
                        <span class="s-text">Spouse</span>
                        <span class="checkmarkCheckbox"></span>
                      </label>
                      <label class="container-one">
                        <input type="checkbox" name="checkbox" value="UnmarriedChildren" [checked]="accepted"
                          (change)="onItemChangeUnmarriedChildren($event)" class="form-check-input" />
                        <span class="s-text">Unmarried Children</span>
                        <span class="checkmarkCheckbox"></span>
                      </label>
                    </div>
                  </div>

                  <label class="control-label">Your total family income (including your income)
                    <span style="color: #ff0000">*</span></label>
                    <input type="text" style="font-family: 'Figtree' !important" class="form-control reason-for" [ngClass]="{
                      'is-invalid':
                        submitted &&
                        b.totalincomebandrange.errors &&
                        b.totalincomebandrange.touched
                    }" 
                    placeholder="" inputmode=" numeric" minlength="4" maxlength="7" formControlName="totalincomebandrange"
                    (keyup)="checkBorrowerIncome($event, 'familyIncome', 'totalincomerange')" [(ngModel)]="totalincomerange"
                    (keyup)="allowOnlyNumbers($event, totalincomerange, 1)" numberonly="incomebandrange">
                  <div *ngIf="
                      b.totalincomebandrange.touched &&
                      b.totalincomebandrange.errors
                    " class="invalid-feedback">
                    <div *ngIf="b.totalincomebandrange.errors.required">
                      <sup>*</sup> Enter Total Family income
                    </div>
                    <div *ngIf="b.totalincomebandrange.errors.pattern">
                      Enter valid amount
                    </div>
                    <div style="font-family: 'Figtree'!important" *ngIf="b.totalincomebandrange.errors.min || b.totalincomebandrange.errors.max">
                      Total Family income must be at least 4 digits or maximium 7 digits
                    </div>
                  </div>
                </div>
                <!-- <label class="control-label" hidden="true"> <input name="chkBox_1" type="checkbox"  checked value="1" readonly/> I hereby declare that my monthly household income (Family income per month Including Borrower's Income) is Rs:{{totalincomerange}}</label> -->
              </div>
              <div *ngIf="this.reasonflag">
                <label class="control-label" style="color: #114984;font-weight: bold;">Update income change reason
                </label>
                <select formControlName="reason" (blur)="onReasonSelectChange($event)" class="form-control reason-for">
                  <option [value]="undefined" selected>Select Reason</option>
                  <option *ngFor="let reason of reasonList" [value]="reason.code">
                    {{reason.reason}}</option>
                </select>
              </div>
            </div>

            <button class="btn btn-save btn-primary mt-3 w-100" [disabled]="submitted" (click)="save($event)">
              Save
            </button>
            <!-- <button class="btn btn-save btn-primary mt-3 w-100"  (click)="clear()" >Clear</button> -->
          </form>
          <!-- <button  class="btn btn-save btn-primary mt-4 w-100"  (click)="payNow()">Pay Now 
                  <i class="fa fa-spinner fa-spin"  *ngIf="loader" ></i>    </button>   -->
        </div>
      </div>
    </div>
  </div>
  <loader *ngIf="loader"></loader>
</div>